import React from "react";


type StatusTypes="warning" | "success" | "error" | "primary";
type AppProps = {
    content: string;
    statusType: StatusTypes;
    className? : string
};

export function getStatusClass(statusType: StatusTypes) {
    if (statusType === "warning") {
        return {
            className: "bg-warning-10  p-1 rounded-md text-xs text-warning-dark text-center inline-block w-[107px]"
        }
    }
    if (statusType === "success") {
        return {
            className: "bg-success-10  p-1 rounded-md text-xs text-success-dark text-center inline-block w-[107px]"
        }
    }
    if (statusType === "error") {
        return {
            className: "bg-error-10  p-1 rounded-md text-xs text-error-dark text-center inline-block w-[107px]"
        }
    }
    if (statusType === "primary") {
        return {
            className: "bg-primary-10  p-1 rounded-md text-xs text-primary-text text-center inline-block w-[107px]"
        }
    }

    return {
        className: "bg-primary-10 p-1 rounded-md text-xs text-primary-text text-center inline-block w-[107px]"
    }

}
const StatusBox = (props: AppProps) => {

    const { statusType, content } = props;


    const { className } = getStatusClass(statusType);

    return (
        <div className={className + " " + props.className } >
            {content}
        </div>
    );

}

export default StatusBox;